import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { PreLoginPeticion } from 'src/app/models/pre-login/PreLogin-peticion';
import { AutenticadorService } from 'src/app/services/autenticador/autenticador.service';
import { CompletarSuscripcionService } from 'src/app/services/completar-suscripcion/completarSuscripcion.service';
import { LoaderBaseService } from 'src/app/services/loader-base.service';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { Estilos } from 'src/app/services/estilos/estilos';
import { ListSuscripcionPeticion } from 'src/app/models/completar-suscripcion/listSuscripcionPeticion';
import { ListPolIntValidTokenSusPeticion } from 'src/app/models/completar-suscripcion/listPolIntValidTokenSusPeticion';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DialogBaseComponent } from '../../dialogs/dialog-base/dialog-base.component';
export interface DialogData {
  title: string;
  content: string;
  showBtnCancel: boolean;
}

@Component({
  selector: 'app-token-sus-comercio',
  templateUrl: './token-sus-comercio.component.html',
  styleUrls: ['./token-sus-comercio.component.css'],
  providers: [CompletarSuscripcionService]
})
export class TokenSusComercioComponent implements OnInit {
  estilos : Estilos = new Estilos();
  listSuscripcionPeticion: ListSuscripcionPeticion = new ListSuscripcionPeticion();
  listPolIntValidTokenSusPeticion: ListPolIntValidTokenSusPeticion = new ListPolIntValidTokenSusPeticion();
  errorValidarToken: boolean = false;
  errorMensage: string = "";
  maxIntentoTokenSusBD: number = 0;
  maxIntentoTokenSus: number = 0;
  preLoginsLS: { codTpoPortal: string; };
  isEmbebido = false;
  urlSalida: string = '';
  urlSalidaEncode: string = '';
  formGroup: FormGroup = new FormGroup({
    tokenSuscripcion: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(20)]))
  });

  constructor(
    //public dialogRef: MatDialogRef<DialogTokenSuscripcionComponent>,
    private loader: LoaderBaseService,
    private completarSuscripcionService: CompletarSuscripcionService,
    public dialog: MatDialog,
    private autenticatorService: AutenticadorService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    @Inject('env') private environment: any,
    private elementRef: ElementRef
  ) {
    this.estilos.cambioEstilos(elementRef);
  }

  ngOnInit() {
    this.activeRoute.queryParams.subscribe((params) => {
      console.log('params token: ', params);
      if (params['url']) {
        const encode1 = decodeURIComponent(params['url']);
        this.urlSalida = decodeURIComponent(encode1);
        this.urlSalidaEncode = params['url'];
      }
    });
    this.preLoginsWait();
  }

  preLoginsWait(){
    let params: PreLoginPeticion = new PreLoginPeticion();
    params.codCliente = environment.codCliente;
    params.urlPortal = environment.urlPortal;

    this.autenticatorService.preLogin(params).subscribe(data => {
      if (data.codret == '0') {
        sessionStorage.setItem('preLogin', JSON.stringify(data));
        sessionStorage.setItem('tokenSession', data.tokenSession);

        this.preLoginsLS = JSON.parse(sessionStorage.getItem('preLogin'));

        this.configSusComercio();
      } else {
        this.loader.hide();
        this.showDialog('Error', 'Ocurri&oacute; un error al obtener la informaci&oacute;n.', false, 'Cancelar', 'Aceptar');
      }
    }, error => {
      this.loader.hide();
      this.showDialog('Error', 'Ocurri&oacute; un error al obtener la informaci&oacute;n.', false, 'Cancelar', 'Aceptar');
    });
  }

  configSusComercio() {
    this.autenticatorService.getLoginSusComercio().subscribe(data => {
      if (data.codret == '0') {
        sessionStorage.setItem('tokenSessionSusComercio', data['tokenSession']);

        this.listPolIntValidTokenSusPeticion.codCliente = this.environment.codCliente;
        this.postListPolIntValidTokenSusServices(this.listPolIntValidTokenSusPeticion);
      } else {
        this.loader.hide();
        this.showDialog('Error', 'Ocurri&oacute; un error al obtener la informaci&oacute;n.', false, 'Cancelar', 'Aceptar');
      }
    }, err => {
      console.error('error: ', err);
      this.loader.hide();
      this.showDialog('Error', 'Ocurri&oacute; un error al obtener la informaci&oacute;n.', false, 'Cancelar', 'Aceptar');
    });
  }

  postListPolIntValidTokenSusServices(body: ListPolIntValidTokenSusPeticion) {
    this.loader.show();
    this.completarSuscripcionService.postListPolIntValidTokenSus(body, this.isEmbebido).subscribe(data => {
      if(data.codret == '0'){
        this.loader.hide();
        this.maxIntentoTokenSusBD = data.resultado[0]['maxIntentoTokenSus'];
        this.maxIntentoTokenSus = this.maxIntentoTokenSusBD;
      }else{
        this.removeSession();
        this.loader.hide();
        this.showDialog('Error', 'Ocurri&oacute; un error al obtener la informaci&oacute;n.', false, 'Cancelar', 'Aceptar');
      }
    }, err => {
      console.error('error: ', err);
      this.removeSession();
      this.loader.hide();
      this.showDialog('Error', 'Ocurri&oacute; un error al obtener la informaci&oacute;n.', false, 'Cancelar', 'Aceptar');
    });
  }

  validarToken(){
    if(this.maxIntentoTokenSusBD == 0){
      this.listSuscripcionPeticion.tokenSuscripcion = this.formGroup.get('tokenSuscripcion').value;
      this.listSuscripcionPeticion.codCliente = this.environment.codCliente;
      this.postListSusComercioServices(this.listSuscripcionPeticion);
    } else if (this.maxIntentoTokenSus > 0){
      this.listSuscripcionPeticion.tokenSuscripcion = this.formGroup.get('tokenSuscripcion').value;
      this.listSuscripcionPeticion.codCliente = this.environment.codCliente;
      this.postListSusComercioServices(this.listSuscripcionPeticion);
    }else{
      this.showDialog('Error', 'Ha excedido la cantidad de intentos permitidos.', false, 'Cancelar', 'Aceptar');
    }
  }

  postListSusComercioServices(body: ListSuscripcionPeticion) {
    this.loader.show();
    this.errorValidarToken = false;
    this.completarSuscripcionService.postListSusComercio(body, this.isEmbebido).subscribe(data => {
      if(data.codret == '0'){
        this.loader.hide();
        sessionStorage.setItem('listSusComercio', JSON.stringify(
          data['resultado'][0]
        ));
        (this.urlSalida != '' ? this.router.navigate(['/suscComercio'], { queryParams: { url: this.urlSalidaEncode } }) : this.router.navigate(['/suscComercio']));
      } else if (data.codret == '-100'){
        this.loader.hide();
        this.maxIntentoTokenSus--;
        this.errorValidarToken = true;
        this.errorMensage = "Token no existe o no se encuentra vigente.";
      } else {
        this.removeSession();
        this.loader.hide();
        this.showDialog('Error', 'Ocurri&oacute; un error al obtener la informaci&oacute;n.', false, 'Cancelar', 'Aceptar');
      }
    }, err => {
      console.error('error: ', err);
      this.removeSession();
      this.loader.hide();
      this.showDialog('Error', 'Ocurri&oacute; un error al obtener la informaci&oacute;n.', false, 'Cancelar', 'Aceptar');
    });
  }

  // onNoClick(valor): void {
  //   this.dialogRef.close(valor);
  // }

  showDialog(pTitle: string, pContent: string, pShowBtnCancel: boolean, pBtnCancelar: string, pBtnAceptar: string) {
    const dialogRef = this.dialog.open(DialogBaseComponent, {
      data: { title: pTitle, content: pContent, showBtnCancel: pShowBtnCancel, btnCancelar: pBtnCancelar, btnAceptar: pBtnAceptar},
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.redirigirUsuario();
      }
    });
  }

  cancelar(){
    this.redirigirUsuario();
  }

  redirigirUsuario() {
    if (this.urlSalida !== '') {
      window.location.href = this.urlSalida;
    } else {
      this.router.navigate(['/inicio']);
    }
  }

  removeSession() {
    sessionStorage.removeItem('tokenSessionSusComercio');
    sessionStorage.removeItem('listSusComercio');
  }

}
